<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="col-12 shadow-btm row">
          <div class="col-lg-6 col-sm-6 my-auto">
            <h4 class="mb-0 lg-bld">Manage Logs</h4>
          </div>
          <div class="col-6 text-right"></div>
        </div>
        <div class="page-content">
          <div class="card-body py-0 px-0">
            <!-- Search Row -->
            <div class="row align-items-center mb-3">

              <!-- Search Input -->
              <div class="col-lg-3 col-sm-4">
                <div class="has-search ml-3">
                  <i
                    class="fa fa-search"
                    style="position: absolute; margin: 10px"
                    aria-hidden="true"
                  ></i>
                  <input
                    type="text"
                    class="form-control"
                    v-on:keyup.enter="getList(0)"
                    placeholder="Search"
                    v-model="searchObj.keyword"
                  />
                </div>
              </div>

              <!-- Type Filter -->
              <div class="col-lg-2 col-sm-4">
                <Multiselect
                  mode="single"
                  track-by="value"
                  label="value"
                  valueProp="id"
                  placeholder="Select Type"
                  v-model="searchObj.type"
                  :options="types"
                  searchable="true"
                  @change="onTypeChange($event)"
                />
              </div>

              <!-- Company Filter -->
              <div class="col-lg-3 col-sm-4" v-if="searchObj.type == 'COMPANY'">
                <Multiselect
                  mode="single"
                  track-by="company_name"
                  label="company_name"
                  valueProp="id"
                  placeholder="Select Company"
                  v-model="searchObj.type_id"
                  :options="companyList"
                  searchable="true"
                  @search-change="searchCompanyName($event)"
                />
              </div>

              <!-- Executive Filter -->
              <div class="col-lg-3 col-sm-4" v-if="searchObj.type == 'EXECUTIVE'">
                <Multiselect
                  mode="single"
                  track-by="executive_name"
                  label="executive_name"
                  valueProp="id"
                  placeholder="Select Executive"
                  v-model="searchObj.type_id"
                  :options="executiveList"
                  searchable="true"
                  @search-change="searchExecutiveName($event)"
                />
              </div>

              <!-- Buttons -->
              <div class="col-lg-4 col-sm-4 d-flex">
                <a
                  class="search-btn btn-style cursor-pointer ml-3 mr-2"
                  v-on:click="getList(0)"
                  >Search</a
                >
                <a
                  class="search-btn btn-style cursor-pointer"
                  v-on:click="resetFilter"
                  v-show="searchObj.keyword || searchObj.type || searchObj.type_id"
                  >Reset</a
                >
              </div>

            </div>
            <div class="card border mb-0 radius-15">
              <div class="card-body p-0 pb-4">
                <div class="table-responsive">
                  <div class="dataTables_wrapper dt-bootstrap4">
                    <table
                      class="table table-striped table-bordered dataTable"
                      style="width: 100%"
                      role="grid"
                      aria-describedby="example_info"
                    >
                      <thead>
                        <tr role="row">
                          <th
                            class="sorting"
                            id="id-name"
                            v-on:click="sorting('tbl_logs.id', 'id-name')"
                          >
                            Sr No
                          </th>
                          <th
                            class="sorting"
                            id="id-name"
                            v-on:click="sorting('admin_name', 'id-name')"
                          >
                            Admin Name
                          </th>
                          <th
                            class="sorting"
                            id="id-email"
                            v-on:click="sorting('descr', 'id-email')"
                          >
                            Activity
                          </th>
                          <th
                            class="sorting"
                            id="id-mobile"
                            v-on:click="sorting('tbl_logs.created_on', 'id-mobile')"
                          >
                            Date
                          </th>
                        </tr>
                      </thead>
                      <tbody v-show="!loader">
                        <tr v-for="(data, index) in list" :key="index">
                          <td>
                            {{
                              ($refs.listPagination.currentPage - 1) * $refs.listPagination.itemsPerPage +
                              index +
                              1
                            }}
                          </td>
                          <td>{{ data.admin_name }}</td>
                          <td>{{ data.descr }}</td>
                          <td>{{ data.created_on }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mx-0 mb-4">
                  <div class="col-lg-12 mt-5 text-center">
                    <div class="page-bottom-pagination text-right">
                      <Pagination
                        @page-change="pageChange"
                        @items-per-page-change="itemsPerPageChange"
                        ref="listPagination"
                      />
                    </div>
                  </div>
                </div>
                <ErrorComponent @retry="getList(0)" ref="errorComponent" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import Pagination from "@/components/Pagination";
import Multiselect from "@vueform/multiselect";

export default {
  name: "Logs",
  components: {
    ErrorComponent,
    Pagination,
    Multiselect,
  },
  data() {
    return {
      loader: true,
      searchObj: {
        keyword: "",
        type: "",
        type_id: "",
      },
      offset: -1,
      list: [],
      types: [
        { id: "COMPANY", value: "Company" },
        { id: "EXECUTIVE", value: "Executive" },
      ],
      companyList: [],
      executiveList: [],
      companyKeyword: "",
      executiveKeyword: "",
    };
  },
  mounted() {
    this.getList(0);
  },
  methods: {
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getList(page, orderBy, sortBy) {
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];
      this.searchObj.offset = page;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      this.$api
        .getAPI({
          _action: "/log/pagination/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.list = res.list;
          this.offset = res.next_offset;
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "No logs list available");
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
    sorting(sortBy, id) {
      var obj = this.$helperService.sorting(sortBy, id);
      this.getList(0, obj.order_by, obj.sort_by);
    },
    onTypeChange(type) {
      // multiselect "change" ko "update:modelValue" se pehle emit karta hai,
      // isliye searchObj.type ke bharose mat raho - event ki value lo
      this.searchObj.type = type;
      // type badalne par purani id aur uski list dono clear
      this.searchObj.type_id = "";
      this.companyList = [];
      this.executiveList = [];
      this.companyKeyword = "";
      this.executiveKeyword = "";
      if (type == "COMPANY") {
        this.getCompanyList();
      } else if (type == "EXECUTIVE") {
        this.getExecutiveList();
      }
    },
    searchCompanyName(e) {
      this.companyKeyword = e;
      this.getCompanyList();
    },
    getCompanyList() {
      var obj = {};
      if (this.companyKeyword) {
        obj.keyword = this.companyKeyword;
      }
      this.$api
        .getAPI({
          _action: "/company/list",
          _body: obj,
        })
        .then((res) => {
          this.companyList = res;
        })
        .catch(() => {});
    },
    searchExecutiveName(e) {
      this.executiveKeyword = e;
      this.getExecutiveList();
    },
    getExecutiveList() {
      var obj = {};
      if (this.executiveKeyword) {
        obj.keyword = this.executiveKeyword;
      }
      this.$api
        .getAPI({
          _action: "/executive/list",
          _body: obj,
        })
        .then((res) => {
          this.executiveList = res;
        })
        .catch(() => {});
    },
    resetFilter() {
      this.searchObj.keyword = "";
      this.searchObj.type = "";
      this.searchObj.type_id = "";
      this.companyList = [];
      this.executiveList = [];
      this.companyKeyword = "";
      this.executiveKeyword = "";
      this.getList(0);
    },
    showDeletePopup(data) {
      this.$refs.deleteModal.showModal(
        "Delete Log",
        "Are you sure you want to delete " + data.name,
        data
      );
    },
    deleteRecord(dataObj) {
      var detail = new Proxy(dataObj, {});
      this.$api
        .deleteAPI({
          _action: "/user/" + detail.uuid,
        })
        .then((res) => {
          if (res) {
            this.$refs.deleteModal.closeModal();
            this.getList();
            this.$notify({
              type: "success",
              text: res.message,
            });
          }
        })
        .catch(() => {
          this.$refs.deleteModal.removeLoader();
        });
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.multiselect {
  background: #f0f0f0;
  height: 35px;
  border: 1px solid;
}

.multiselect-tag {
  background: #9cc338 !important;
}
</style>